import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/v2-node-api/services/data.service';
import { endpoints } from 'src/app/v2-node-api/common/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService extends DataService  {

  constructor( http: HttpClient) {
    super(endpoints.kanban, http);
   }

  upload($event,namefile,kanbanId, columnId, task){

    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: task.description,
      affectto: task.affectto,
      document: task.file,
      dueDate: task.dueDate,
      like: task.like,
      comments: task.comments,
      base64: $event,
      nameFile: namefile,
      text: task.title,
      cloture: task.cloture
    }


    return this.http.put<any[]>(endpoints.kanban + `add-file/${kanbanId}/${columnId}/${task._id}`, newCard)
  }

  removeFile(kanbanId, columnId, task){
    const newCard = {
      id: task._id,
      order: task.order,
      author: task.author,
      description: task.description,
      affectto: task.affectto,
      document: task.file,
      dueDate: task.dueDate,
      like: task.like,
      comments: task.comments,
      nameFile: "",
      base64: "",
      text: task.title,
      cloture: task.cloture
    }

    return this.http.put<any[]>(endpoints.kanban + `add-file/${kanbanId}/${columnId}/${task._id}`, newCard)

  }

  seeFile(fileId){
    return this.http.get(endpoints.kanban + `file/${fileId}`);
  }
}
